module.exports = __webpack_public_path__ + "static/media/ES.1027ee4f.png";